import React, { useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import Subnav from 'components/Subnav';
import { Outlet } from 'react-router-dom';

import './BossModeStats.styles.scss';

type BossModeStatsProps = {
  className?: string;
};

const BossModeStats: React.FC<BossModeStatsProps> = (props) => {
  const { className } = props;

  const { t } = useTranslation();

  const classes = classNames('boss-mode-stats', className);

  const links = useMemo(
    () => [
      {
        to: 'forensics',
        label: t('forensics'),
      },
      {
        to: 'suggested-actions',
        label: t('suggestedActionsLc'),
      },
    ],
    [t],
  );

  return (
    <div className={classes}>
      <h1>{t('bossModeOperations')}</h1>

      <Subnav links={links} />

      <Outlet />
    </div>
  );
};

export default BossModeStats;
